// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextFieldProps } from '@mui/material';
//
import Editor from '../editor';

// ----------------------------------------------------------------------

type IProps = {
  name: string;
};

type Props = IProps & TextFieldProps;

export default function RHFEditor({ name, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Editor
          id={name}
          value={field.value}
          fullWidth
          onChange={field.onChange}
          error={!!error}
          placeholder={other.placeholder}
          helperText={error?.message}
          {...other}
        />
      )}
    />
  );
}
